var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecurring(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#recurring_svg__clip0_31_3069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.542 3.747V6.69l2.446 1.467a.542.542 0 11-.558.93L6.72 7.46a.542.542 0 01-.262-.464v-3.25a.542.542 0 111.083 0zM13.5 2.122a.542.542 0 00-.541.541v1.22c-.43-.5-.869-.98-1.363-1.479a6.5 6.5 0 10-.135 9.323.541.541 0 10-.745-.788 5.417 5.417 0 11.113-7.775 30.448 30.448 0 011.52 1.666h-1.557a.541.541 0 100 1.083H13.5a.542.542 0 00.542-.541V2.663a.542.542 0 00-.542-.541z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "recurring_svg__clip0_31_3069"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
}
export default SvgRecurring;